import React from 'react';
import styled, { keyframes } from 'styled-components';

const move = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const RibbonWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  background-color: #F7E03C;
  border-top: 4px solid #000;
  border-bottom: 4px solid #000;
  padding: 10px 0;
  display: flex;
  white-space: nowrap;
`;

const RibbonTrack = styled.div`
  display: inline-flex;
  animation: ${move} 10s linear infinite;
  font-family: 'GROBOLD', sans-serif;
  font-size: 24px;
  color: #000;
  text-transform: uppercase;
`;

export const RibbonMarquee: React.FC = () => {
  const text = Array(20).fill("#CC8 $ZEUS").join(" • ");
  return (
    <RibbonWrapper>
      <RibbonTrack>
        {text} • {text}
      </RibbonTrack>
    </RibbonWrapper>
  );
};
